import { EventDispatcher } from 'three';
import { QuizActionEvent, QuizActionType } from '../../constants/QuizActionEvent';
import { QuestionComponent } from './QuestionComponent';
import { CommentAndButtonComponent } from './CommentAndButtonComponent';
import { ResultComponent } from './ResultComponent';
import { tag } from '../../utils/tag';

export class View extends EventDispatcher {
    #isStartPage = true;
    #viewport;
    #questionComp = null;
    #commentComp = null;
    #resultComp = null;
    #questionId = null;
    #scoreValueEl = null;
    #incrementEl = null;

    constructor() {
        super();
        this.#viewport = document.getElementById('viewport');
    }

    start() {
        const removeActions = (action, lstr) => {
            [...document.querySelectorAll(`[data-action="${action}"]`)].forEach((elem) => {
                elem.removeEventListener('click', lstr);
            });
        };
        const listener = (evt) => {
            let { currentTarget } = evt;
            const { target } = evt;

            currentTarget = currentTarget || target;

            if (!currentTarget) return;

            const { action } = currentTarget.dataset;

            if (!action) return;

            if (action === QuizActionType.START) {
                this.dispatchEvent({
                    type: QuizActionEvent,
                    action: {
                        type: QuizActionType.START
                    }
                });
                // START ONCE
                removeActions(action, listener);
            }
        };

        [...document.querySelectorAll('[data-action]')].forEach((elem) => {
            elem.addEventListener('click', listener);
        });
    }

    showQuestion(data, index, numTotal /* , prevIncrement = 0 */) {
        this.#hidePrevQuestion();

        const questionComp = this.#questionComp || new QuestionComponent(data);

        if (this.#questionComp) {
            questionComp.data = data;
        } else {
            this.#addCompTransferListener(questionComp, QuizActionEvent);
            this.#addCompTransferListener(questionComp, 'change');
        }

        questionComp.decorateBefore(tag('p', null, `${index + 1} из ${numTotal}`));
        questionComp.renderTo(this.#viewport);

        this.#questionComp = questionComp;
        this.#questionId = data.id;
    }

    showComment(data, index, numTotal, increment, nextLabel = 'next') {
        if (!this.#questionComp) return;

        const actionEvent = {
            type: QuizActionEvent,
            action: {
                type: QuizActionType.NEXT,
                fromId: this.#questionId
            }
        };
        const commentComp = this.#commentComp || new CommentAndButtonComponent(
            data,
            nextLabel,
            actionEvent
        );

        if (this.#commentComp) {
            commentComp.text = data;
            commentComp.actionEvent = actionEvent;
        } else {
            this.#addCompTransferListener(commentComp, QuizActionEvent);
        }

        this.#questionComp.appendComment(commentComp);
    }

    disableOptions() {
        if (!this.#questionComp) return;

        this.#questionComp.disableOptions();
    }

    hideQuestion() {
        this.#hidePrevQuestion();
    }

    /* displayAnswerStatus(status) {
        console.log(status, this);
    } */

    #hidePrevQuestion() {
        if (!this.#questionComp) return;

        this.#questionComp.remove(true);
    }

    showResult(data, restartLabel) {
        const resultComp = new ResultComponent(data, restartLabel, {
            type: QuizActionEvent,
            action: {
                type: QuizActionType.RESTART
            }
        });

        resultComp.renderTo(this.#viewport);
        this.#addCompTransferListener(resultComp, QuizActionEvent);

        this.#resultComp = resultComp;
    }

    hideResult() {
        if (!this.#resultComp) return;

        this.#resultComp.remove(true);
        this.#resultComp = null;
    }

    showScore() {
        if (this.#scoreValueEl !== null) return;

        const rootEl = tag('p', 'score', 'Ваш счет: ');
        const mainEl = tag('strong', 'score__value');
        const textNode1 = document.createTextNode('(изменился на ');
        const incrementEl = tag('span', 'score__increment__value');
        const textNode2 = document.createTextNode(').');

        rootEl.appendChild(mainEl);
        rootEl.appendChild(textNode1);
        rootEl.appendChild(incrementEl);
        rootEl.appendChild(textNode2);

        this.#viewport.appendChild(rootEl);
        this.#scoreValueEl = mainEl;
        this.#incrementEl = incrementEl;
    }

    hideScore() {
        if (!this.#scoreValueEl) return;

        if (!this.#scoreValueEl.parentNode || !this.#scoreValueEl.parentNode.parentNode) {
            this.#scoreValueEl = null;
            this.#incrementEl = null;

            return;
        }

        this.#scoreValueEl.parentNode.parentNode.removeChild(this.#scoreValueEl.parentNode);
        this.#scoreValueEl = null;
        this.#incrementEl = null;
    }

    updateScore(totalScore, currentIncrement) {
        if (!this.#scoreValueEl) return;

        this.#scoreValueEl.innerText = totalScore;
        this.#incrementEl.innerText = currentIncrement;
    }

    #addCompTransferListener(comp, event) {
        comp.addEventListener(event, (evt) => {
            // TRANSFER AN EVENT
            this.dispatchEvent({
                ...evt
            });
        });
    }

    hideStart() {
        if (!this.#isStartPage) return;

        document.body.classList.add('quiz-started');

        this.#isStartPage = false;
    }
}
